import { IEditDeviceState } from './editDeviceContext';
import { EditDeviceActionTypes, TEditDeviceAction } from './editDeviceActions';

export const editDeviceReducer = (state: IEditDeviceState, action: TEditDeviceAction): IEditDeviceState => {
	switch (action.type) {
		case EditDeviceActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case EditDeviceActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditDeviceActionTypes.SET_ALL_DATA:
			return {
				...state,
				deviceId: action.payload.deviceId,
				hardwareId: action.payload.hardwareId,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				bankSettings: action.payload.bankSettings,
				availableRestaurantBankSettings: action.payload.availableRestaurantBankSettings,
				tlsCertificateName: action.payload.tlsCertificateName,
				tlsCertificateFilePath: action.payload.tlsCertificateFilePath,
				tlsCertificateFileId: action.payload.tlsCertificateFileId,
			};
		case EditDeviceActionTypes.CHANGE_HARDWARE_ID:
			return {
				...state,
				hardwareId: action.payload.hardwareId,
			};
		case EditDeviceActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
			};
		case EditDeviceActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDSelectedRestaurant: null,
				bankSettings: [],
			};
		case EditDeviceActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case EditDeviceActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				bankSettings: [],
			};
		case EditDeviceActionTypes.SET_BANK_SETTINGS:
			return {
				...state,
				bankSettings: action.payload.bankSettings,
			};
		case EditDeviceActionTypes.ADD_BANK_SETTINGS_BLOCK:
			return {
				...state,
				bankSettings: [...state.bankSettings, action.payload.bankSettings],
			};
		case EditDeviceActionTypes.SET_FETCHED_RESTAURANT_BANK_SETTINGS:
			return {
				...state,
				fetchedRestaurantBankSettings: action.payload.fetchedRestaurantBankSettings,
			};
		case EditDeviceActionTypes.SET_TLS_CERTIFICATE_LEVEL:
			return {
				...state,
				tlsCertificateLevel: action.payload.tlsCertificateLevel,
				tlsCertificateName: action.payload.tlsCertificateName,
				tlsCertificateFilePath: action.payload.tlsCertificateFilePath,
				tlsCertificateFileId: action.payload.tlsCertificateFileId,
				tlsCertificateFileHash: action.payload.tlsCertificateFileHash,
			};
		case EditDeviceActionTypes.CHANGE_TLS_CERTIFICATE_NAME:
			return {
				...state,
				tlsCertificateName: action.payload.tlsCertificateName,
			};
		case EditDeviceActionTypes.SET_TLS_CERTIFICATE_FILE:
			return {
				...state,
				tlsCertificateFileId: action.payload.tlsCertificateFileId,
				tlsCertificateFileHash: action.payload.tlsCertificateFileHash,
				tlsCertificateFilePath: null,
			};
		case EditDeviceActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditDeviceActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditDeviceActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case EditDeviceActionTypes.RESET_FIELDS:
			return {
				...state,
				hardwareId: '',
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				fetchedRestaurants: [],
				IDSelectedRestaurant: null,
				bankSettings: [],
				tlsCertificateLevel: null,
				tlsCertificateName: null,
				tlsCertificateFilePath: null,
				tlsCertificateFileId: null,
				tlsCertificateFileHash: null,
				fetchedRestaurantBankSettings: [],
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
